import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VuexPersist from 'vuex-persist';
import { router } from '../_helpers';

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production';
const API_URL = process.env.VUE_APP_API_URL || 'http://192.168.1.31:8090';

// APP global VUEX STATE
const state = {
  loggedIn: false,
  isLoading: false,
  caller: '',
  machines: [],
  user:{},
  snackbar:{"text":"Welcome to iottlyVPN!",'color':''},

  // websocket connection state
  socket: {
    isConnected: false,
    reconnectError: false
  }
}

const getters = {
  machine: (state) => () => {
    return state.machines;
  },
  loading: (state) => () => {
    return state.isLoading;
  }
}

// VUEX MUTATIONS
const mutations = {
  RESET_SNACKBAR: (state) => {
    state.snackbar.color = '';
    state.snackbar.text = '';
  },
  ERROR: (state) => {
    state.loggedIn=false;
    state.user = {};
    state.machines = [];
    state.snackbar.color = 'error';
    state.snackbar.text = 'Connection error.';
    router.push('/login');
  },
  ERROR_VPN_START: (state, payload) => {
    state.isLoading = false;
    var data = payload.data.vpn_start;
    state.snackbar.color = data.state;
    state.snackbar.text = data.msg;
  },
  ERROR_VPN_STOP: (state, payload) => {
    state.isLoading = false;
    var data = payload.data.vpn_stop;
    state.snackbar.color = data.state;
    state.snackbar.text = data.msg;
  },
  LOGIN_USER_DATA: (state, payload) => {
    if (!payload) {
      return
    }
    var data = payload.data;
    state.snackbar.color = data.login.state;
    state.snackbar.text = data.login.msg;

    if(data.login.state == 'success'){
      state.loggedIn=true;
      state.user = data.login;
      router.push('/');
    }else{
      state.loggedIn=false;
      state.user = {};
      state.machines = [];
      router.push('/login');
    }

    state.caller = payload.data.caller;
  },
  LOGOUT_USER_DATA: (state, payload) => {
    if (!payload) {
      return
    }
    var data = payload.data.logout;
    state.snackbar.color = data.state;
    state.snackbar.text = data.msg;

    // if(data.state == 'success'){
      state.loggedIn=false;
      state.user = {};
      state.machines = [];
      router.push('/login')
    // }
    state.caller = payload.data.caller;

  },
  LOAD_MACHINE_DATA: (state, payload) => {
    if (!payload) {
      return
    }

    var data = payload.data;
    if(data.machines.state == 'error'){
      state.loggedIn=false;
      state.user = {};
      state.machines = [];
      router.push('/login');
    }else{
      state.machines = data.machines;
      state.caller = payload.data.caller;
    }
  },
  UPDATE_VPN_STATUS:(state,data)=>{

    if (data.data != undefined){
      var UUIDConnected = ''
      var enableOther = false
      var UUIDDisconnected = ''
      if(data.data.status == 'up'){

        state.machines.forEach((machine) => {
          if(machine.UUID== data.UUID){
            machine.connected=true;
            machine.userConnected=data.user_name;
            machine.offline=false;
            machine.enabled = true;

            if(state.user.user_name != data.user_name)
              machine.enabled = false;
            else
              UUIDConnected = machine.UUID

            if(data.type == 'vpn_start'){
              state.snackbar.color = "green";
              state.snackbar.text = machine.plant ? machine.plant + " " :
              "" + machine.name + " connected.";
            }
            return;
          }
        })
      }else if(data.data.status == 'down'){

        state.machines.forEach((machine) => {
          if(machine.UUID == data.UUID){

            if( machine.connected == true && machine.userConnected == state.user.user_name) {
              //ENABLE TUTTE TRANNE QUELLE CONNESSE DA ALTRI
              machine.enabled = true;
              enableOther = true
            }else if(machine.connected == true && machine.userConnected != state.user.user_name){
              UUIDDisconnected = machine.UUID
            }

            machine.connected = false;
            machine.userConnected='';
            machine.offline=false;

            if(data.type == 'vpn_stop'){
              state.snackbar.color = "green";
              state.snackbar.text = machine.plant ? machine.plant + " " :
              "" + machine.name + " disconnected.";
            }
            return;
          }
        })
      }

      if(UUIDConnected != ''){
        state.machines.forEach((machine) => {
          if(machine.UUID != UUIDConnected)
            machine.enabled = false
        })
      }
      if(UUIDDisconnected != ''){
        var otherUserConnected = false
        state.machines.forEach((machine) => {
          if(machine.connected == true){
            otherUserConnected = true;
            return;
          }
        })
        if(otherUserConnected != true){
          state.machines.forEach((machine) => {
            if(machine.UUID == UUIDDisconnected)
              machine.enabled = true;
              return;
          })
        }
      }

      if(enableOther){
        state.machines.forEach((machine) => {
          if(machine.connected == false)
            machine.enabled = true
        })
      }
    }
  },
  UPDATE_CONNECTION_STATUS:(state,data)=>{
      var arrFound,keyFound = Object.keys(state.machines).filter(function(key) {
        return state.machines[key].UUID == data.UUID;
      }).reduce(function(obj, key){
          return key;
      }, undefined);
      if(keyFound != undefined){
        if(data.connectionstatus == 'connected' ){
          state.machines[keyFound].offline = false;
        }else if(data.connectionstatus == 'disconnected' ){
          if(state.machines[keyFound].connected == true){
            state.machines[keyFound].connected = false;
            state.machines.forEach((machine) => {
              machine.enabled = true;
            })
          }
          state.machines[keyFound].offline = true;
        }
      }
  },
  // PAGE LOADING
  PAGE_LOADING (state,caller) {
    state.caller = caller;
    state.isLoading = true;
  },
  PAGE_LOADED (state,caller) {
    if(caller == state.caller || caller == 'RESET')
      state.isLoading = false;
  },
  // WEB SOCKET MUTATIONS
  SOCKET_ONOPEN (state) {
    state.socket.isConnected = true;
  },
  SOCKET_ONCLOSE (state) {
    state.socket.isConnected = false;
  },
  SOCKET_ONERROR (state, event) {
    console.error(state, event)
    // TODO handle error
    state.isLoading = false;
    state.socket.isConnected = false;
    this.commit('PAGE_LOADED', 'RESET');
  },
  // default handler called for all methods
  SOCKET_ONMESSAGE (state, message) {

    var msg = JSON.parse(message.data);
    // Preserve compatibility with iottly SDK v1.0.0
    var payload = msg.payload.payload || msg.payload;

    if(msg.type == 'connectionstatus'){
      this.commit('UPDATE_CONNECTION_STATUS',{
        UUID:msg.device,
        connectionstatus:payload.connectionstatus
      });
    }else{
      this.commit('UPDATE_VPN_STATUS',{
        UUID:payload.UUID,
        user_name:payload.user_name,
        data:payload.vpn,
        type:payload.type,
      });

      if(payload.type == payload.type){
        this.commit('PAGE_LOADED', payload.type);
      }
    }
  },
  // mutations for reconnect methods
  SOCKET_RECONNECT (state, count) {
    console.info(state, count);
  },
  SOCKET_RECONNECT_ERROR (state) {
    state.socket.reconnectError = true;
    state.isLoading = false;
  }
}


// VUEX ACTIONS
const actions = {
  reset_snackbar: (context) => {
    context.commit('RESET_SNACKBAR')
  },
  loadVPNMachines: (context) => {
    return new Promise(() => {
      axios.get(API_URL + '/api/machines/',{headers:{ "Authentication": "bearer " + context.state.user.token }})
        .then(r => r.data)
        .then(d => {
            d.caller = 'LOAD_MACHINE_DATA'
            context.commit('LOAD_MACHINE_DATA', {data: d})
            context.commit('PAGE_LOADED','LOAD_MACHINE_DATA')
        })
    })
  },
  vpn_start: (context, MachineUuid) => {
    context.commit('PAGE_LOADING','vpn_start')
    axios.post(API_URL + '/api/vpn_start/',{"machine_uuid":MachineUuid},{headers:{ "Authentication": "bearer " + context.state.user.token }})
    .then(
      (r) => {
        r.caller = 'ERROR_VPN_START',
        context.commit('ERROR_VPN_START', {data: r.data})
      },(e) => {
        context.commit('ERROR');
      }
    )
  },
  vpn_stop: (context, MachineUuid) => {
    context.commit('PAGE_LOADING','vpn_stop')
    axios.post(API_URL + '/api/vpn_stop/',{"machine_uuid":MachineUuid},{headers:{ "Authentication": "bearer " + context.state.user.token }})
    .then(
      (r) => {
        r.caller = 'ERROR_VPN_STOP',
        context.commit('ERROR_VPN_STOP', {data: r.data})
      },(e) => {
        context.commit('ERROR');
      }
    )
  },
  vpn_status: (context) => {
    axios.get(API_URL + '/api/vpn_status/',{headers:{ "Authentication": "bearer " + context.state.user.token }})
    .then((r) => { r.data },(e) => {
      context.commit('ERROR');
      }
    )
  },
  vpn_login: (context,args) => {
    axios.post(API_URL + '/api/login/',{"user_name":args['user_name'],"password":args['password']})
    .then(r => r.data)
    .then(d => {
        d.caller = 'LOGIN_USER_DATA'
        context.commit('LOGIN_USER_DATA', {data: d})
    })
  },
  vpn_logout: (context) => {
    axios.get(API_URL + '/api/logout/',{headers:{ "Authentication": "bearer " + context.state.user.token }})
    .then(r => r.data)
    .then(d => {
        d.caller = 'LOGOUT_USER_DATA'
        context.commit('LOGOUT_USER_DATA', {data: d})
    },(error) => {
      context.commit('ERROR');
    })
  },
  downloadClientFile: (context) => {
    axios({
      url: API_URL + '/api/downloadClientFile/',
      method: 'GET',
      headers:{ "Authentication": "bearer " + context.state.user.token },
      responseType: 'blob',
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'iottlyVPN_installer.exe');
      document.body.appendChild(link);
      link.click();
    },(error) => {
      context.commit('ERROR');
    })

  },
  downloadClientCertificate: (context) => {
    axios({
      url: API_URL + '/api/downloadClientCertificate/',
      method: 'GET',
      headers:{ "Authentication": "bearer " + context.state.user.token },
      responseType: 'blob',
    }).then((response) => {
           const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'iottlyVPN_configuration.ovpn');
      document.body.appendChild(link);
      link.click();
    },(error) => {
      context.commit('ERROR');
    })

  }
}


const vuexLocalStorage = new VuexPersist({
  key: 'vuex',
  storage: localStorage
})




export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {},
  strict: debug,
  plugins: [vuexLocalStorage.plugin]
})
